<template>
  <OrderItemApplyAllPopover ref="applyPopover" headerTitle="Apply Service" :itemList="validServiceItemList" :disabled="!hasStock" @applySettings="applySettings">

    <FormSearchableSelect
      :options="itemStockLookup"
      :value="stockId"
      :dropdownAutoWidth="true"
      @input="setItemStockId($event)"
      placeholder="Stock Code" />

    <Spinner v-if="loading" />
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>

    <div class="m-3" v-if="!loading" />
    
    <template v-if="!loading && isEdgeworkService">
      <EdgeworkSelection v-model="flagList" />

      <div class="m-3" />
    </template>

  </OrderItemApplyAllPopover>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import OrderItemApplyAllPopover from '@/modules/orders/components/orderItemApplyAllPopover.vue'
import EdgeworkSelection from '@/modules/orders/components/edgeworkSelection'

import { InventoryStockTypes, UOMTypes, OrderItemEdgeworkTypes, OrderItemEdgeworkTypeLookup } from '@/store/types'

export default {
  name: 'OrderItemApplyAllServicePopover',
  mixins: [form],
  components: {
    OrderItemApplyAllPopover,
    EdgeworkSelection
  },
  props: {
    stockLookupList: Array,
    itemList: Array
  },
  computed: {
    itemStockLookup() {
      return this.stockLookupList.filter(stockLookup => stockLookup.type == InventoryStockTypes.glassService)
    },
    isEdgeworkService() {
      if(this.stockId == null)
        return false
      // Only items with lineal-metres UoM can have edgework
      return this.stock.uomType == UOMTypes.length
    },
    hasStock() {
      return this.stockId != null
    }
  },
  data() {
    return {
      stockId: null,
      stock: {},
      loading: false,
      loadingError: '',
      flagList: [],
      validServiceItemList: []
    }
  },
  created() {
    this.OrderItemEdgeworkTypes = OrderItemEdgeworkTypes
  },
  methods: {
    displayFromElement(element) {
      this.flagList = []
      this.stockId = null
      this.stock = {}

      this.validServiceItemList = this.itemList
      .filter(item => {
        if(item.stockType != InventoryStockTypes.glass)
          return false
        if(item.stockPriceGroup && item.stockPriceGroup.isStockLinked)
          return false
        return true
      })
      .map(item => {
        var info = ` - ${item.glassHeight}x${item.glassWidth}`
        return {
          id: item.id,
          name: `${item.stock.code} - ${item.stock.name}${info}`
        }
      })

      this.$refs.applyPopover.displayFromElement(element)
    },
    setItemStockId(stockId) {
      if(stockId == null) {
        this.stockId = null
        return
      }

      this.loading = true
      this.loadingError = ''

      // Query the stock info
      this.stockId = stockId
      this.$apiService.inventoryService.getStock(this.stockId)
      .then(response => {
        this.stock = {
          id: response.data.id,
          code: response.data.code,
          name: response.data.name,
          uomType: response.data.uomType
        }
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    applySettings(itemList) {

      this.$emit('addService', {
        stockId: this.stockId,
        edgeworkFlagList: this.flagList,
        itemList: itemList
      })
    }
    
  }
}
</script>